import { render, staticRenderFns } from "./carnivalInquiries.vue?vue&type=template&id=476cbdab&scoped=true&"
import script from "./carnivalInquiries.vue?vue&type=script&lang=js&"
export * from "./carnivalInquiries.vue?vue&type=script&lang=js&"
import style0 from "./carnivalInquiries.vue?vue&type=style&index=0&id=476cbdab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476cbdab",
  null
  
)

export default component.exports